module.exports = __webpack_public_path__ + "static/media/logo-st-label-below.f95b2f8f.png";